import React from "react";
import { useHistory } from "react-router-dom";
import Proptypes from "prop-types";
import appLogo from "assets/logo/logo-only.png";
import "./index.scss";

const Navbar = ({ type }) => {
  const history = useHistory();
  return (
    <div className="payment-navbar">
      <div className="details">
        <img alt="dflogo" src={appLogo} />
      </div>
      {type === "zoning" && (
        <>
          <div className="details">
            <div className="type">VRT Zoning</div>
          </div>
        </>
      )}
      {type === "stack" && (
        <>
          <div className="details">
            <div className="type">Stack Analysis</div>
            <a className="order-link" href="/">
              View order
            </a>
          </div>
        </>
      )}
      <button
        type="button"
        className="action"
        onClick={() => history.goBack()}
        aria-hidden
      >
        Discard & Leave
      </button>
    </div>
  );
};

Navbar.defaultProps = {
  type: "",
};

Navbar.propTypes = {
  type: Proptypes.string,
};

export default Navbar;
